<!-- File: app.vue (or your main app component) -->
<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <AppSettingsModal :isOpen="isAppSettingsModalOpen" @update:isOpen="updateAppSettingsModal" />
    <BeforeAfterOverlay />
    <Toaster />
  </div>
</template>

<script setup>
import { ref, provide, onMounted } from 'vue'
import AppSettingsModal from '~/components/AppSettingsModal.vue'
import BeforeAfterOverlay from '~/components/BeforeAfterOverlay.vue'
import Toaster from '@/components/ui/toast/Toaster.vue'
import { useTheme } from '@/composables/useTheme'

const isAppSettingsModalOpen = ref(false)

const openCreateProjectPopup = () => {
  isAppSettingsModalOpen.value = true
}

const updateAppSettingsModal = (open) => {
  isAppSettingsModalOpen.value = open
}

provide('openCreateProjectPopup', openCreateProjectPopup)

// Initialize theme globally
const { initializeTheme } = useTheme()

onMounted(() => {
  initializeTheme()
})
</script>
